import type { ReactNode } from "react";
import { CredentialFormFieldInput } from "@/features/credentials/components/credential-edit-modal/credential-form-field";
import { PROFILE_FORM_STYLES } from "@/components/Forms/profile-form-styles";
import type { CredentialFormField } from "@api/shared-runtime/credential-form-descriptors";
import type { CredentialFormValues } from "@/features/credentials/components/credential-edit-modal/credential-form-values";
import {
  PERSONAL_INFO_FIELD_GROUPS,
  personalInfoFieldKey,
} from "./personal-info-fields";

export function PersonalInfoForm({
  values,
  baseline,
  disabled,
  onChange,
  professionalSection,
}: {
  values: CredentialFormValues;
  baseline?: CredentialFormValues;
  disabled: boolean;
  onChange: (key: string, value: string | boolean) => void;
  professionalSection?: ReactNode;
}) {
  return (
    <div className="space-y-6">
      {PERSONAL_INFO_FIELD_GROUPS.map((group) => {
        if (group.key === "professional" && professionalSection !== undefined) {
          return <div key={group.key}>{professionalSection}</div>;
        }
        return (
          <fieldset key={group.key} className={PROFILE_FORM_STYLES.section}>
            <legend className="sr-only">{group.label}</legend>
            <p
              aria-hidden="true"
              className={PROFILE_FORM_STYLES.sectionHeading}
            >
              {group.label}
            </p>
            <div className="grid gap-x-5 gap-y-5 sm:grid-cols-2">
              {group.fields.map((field) => {
                const key = personalInfoFieldKey(group.key, field.key);
                const value = values[key] ?? "";
                const inputField: CredentialFormField = {
                  ...field,
                  source: "details",
                  key: `${group.key}.${field.key}`,
                };
                if (
                  inputField.kind === "select" &&
                  typeof value === "string" &&
                  value &&
                  !inputField.options?.some((option) => option.value === value)
                ) {
                  inputField.options = [
                    { value, label: value },
                    ...(inputField.options ?? []),
                  ];
                }
                return (
                  <CredentialFormFieldInput
                    key={key}
                    field={inputField}
                    appearance="profile"
                    value={value}
                    disabled={disabled}
                    changedFrom={
                      baseline && value !== baseline[key]
                        ? baseline[key]
                        : undefined
                    }
                    onRevert={() => onChange(key, baseline?.[key] ?? "")}
                    onChange={(value) => onChange(key, value)}
                  />
                );
              })}
            </div>
          </fieldset>
        );
      })}
    </div>
  );
}
